import { Layout } from 'antd';
import React from 'react';
import { isMobile } from 'react-device-detect';
import { Link } from 'react-router-dom';

import { ApiStatusBadge } from '../components/ApiStatusBadge/ApiStatusBadge';
import { CreditStatusNotice } from '../components/CreditStatusNotice';
import { InstagramCarousel } from '../components/InstagramCarousel';
import { MediaMentions } from '../components/MediaMentions';
import { routeNames } from '../constants/routes';
import { ModesOverview } from '../containers/ModesOverview';

const { Content } = Layout;

export const Home = () => {
    return (
        <div className="home-overview">
            <div className="home-overview-hero">
                <h1>Poznávej Česko!</h1>

                <h2 className={!isMobile ? 'tooltip-text' : undefined}>
                    Žádná věda... český <b>GeoGuessr</b> nad{' '}
                    <a href={`https://developer.mapy.com/cs/rest-api/`} target="_blank" rel="noopener noreferrer">
                        Mapy.com
                    </a>
                </h2>

                <CreditStatusNotice
                    title="Dobrá zpráva: jedeme dál. Jen s omezenými kredity."
                    tone="info"
                    style={{ maxWidth: 700, width: '100%', margin: '0.75rem 0' }}
                >
                    Hra běží na novém API s <Link to={`/${routeNames.endIsNear}`}>omezenými měsíčními kredity</Link>.
                    Když dojdou, hry s panoramaty si dají na chvíli pauzu a dočasně nepoběží.
                </CreditStatusNotice>
            </div>
            <Content>
                <ModesOverview />
                <div style={{ marginTop: '2.5rem' }}>
                    <MediaMentions />
                </div>
            </Content>
            <ApiStatusBadge />
        </div>
    );
};
